module.exports = __webpack_public_path__ + "img/albert.b21de7ad.jpg";